import { render } from "./SubServiciosList.vue?vue&type=template&id=88be6440&scoped=true"
import script from "./SubServiciosList.vue?vue&type=script&lang=js"
export * from "./SubServiciosList.vue?vue&type=script&lang=js"

import "./SubServiciosList.vue?vue&type=style&index=0&id=88be6440&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\clogistica_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88be6440"]])

export default __exports__